// import { TKIconClose } from 'assets/images/svgs'
import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React from "react";
import InputField from "shared/InputField";
import ProgressBar from "../components/ProgressBar";
import { useFormik } from "formik";
import { createProject3ValidationSchema } from "validation/ngo/project/createProject3Schema";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewProject,
  getProjects,
  updateProject,
} from "appState/project/projectSlice";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { TKIconSpinner } from "assets/images/svgs";

const CreateProjectThree = ({ body }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  const { isLoading } = useSelector((state) => state.project);

  const formik = useFormik({
    initialValues: {
      name_of_account: state ? state.name_of_account : "",
      beneficiary_bank: state ? state.beneficiary_bank : "",
      account_number: state ? state.account_number : "",
      signatories: state ? state.signatories : "",
    },
    validationSchema: createProject3ValidationSchema,
    onSubmit: (values) => {
      const projectBody = {
        name_of_account: values.name_of_account,
        beneficiary_bank: values.beneficiary_bank,
        account_number: values.account_number,
        signatories: values.signatories,
      };
      state
        ? dispatch(
            updateProject({
              projectId: state?._id,
              ...body,
              name_of_account: projectBody.name_of_account,
              beneficiary_bank: projectBody.beneficiary_bank,
              account_number: projectBody.account_number,
              signatories: projectBody.signatories,
            })
          ).then((data) => {
            const { payload } = data;
            if (payload?.status === 200) {
              toast.success("Project edited successfully");
              dispatch(getProjects()).then(() => {
                let path = "/ngo/projects";
                navigate(path);
              });
            }
          })
        : dispatch(
            createNewProject({
              ...body,
              name_of_account: projectBody.name_of_account,
              beneficiary_bank: projectBody.beneficiary_bank,
              account_number: projectBody.account_number,
              signatories: projectBody.signatories,
            })
          ).then((data) => {
            const { payload } = data;
            if (payload?.status === 200) {
              toast.success("Project created successfully");
              dispatch(getProjects()).then(() => {
                let path = "/ngo/projects";
                navigate(path);
              });
            }
          });
    },
  });

  return (
    <NGODashboardLayout section="Create New Project">
      <div className="flex flex-col px-6 max-[450px]:px-0 gap-4">
        <ProgressBar progress="w-[100%]" />
        <div>
          <div className="flex flex-col">
            <div className="flex justify-between items-center">
              <p className="text-[#222] font-semibold text-[28px]">
                Create Project
              </p>
              {
                // <TKIconClose />
              }
            </div>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              Please provide information about the projects you will like
              fundraise for on the Truekeepers website.
            </p>
            <p className="text-[#7A7A7A] text-[18px] font-light">
              <span className="font-bold">Note:</span> You can list information
              for a maximum of 3 projects
            </p>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-3">
                <p className="text-[#213874] text-[14px] whitespace-nowrap">
                  Project Details
                </p>
                <div className="h-[1px] w-full bg-[#CCC]"></div>
              </div>
              <p className="text-[#7A7A7A] font-light">
                In this section, please provide your Organization's bank account
                details for monetary donations. <br />
                <span className="font-medium">Note:</span> The account name must
                correspond to the name of your organization, personal account
                details will not be accepted for the purposes of receiving
                monetary donations
              </p>
            </div>
            <InputField
              name="name_of_account"
              label="Name of Account"
              numberLabel="1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name_of_account}
            />
            {formik.touched.name_of_account && formik.errors.name_of_account ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.name_of_account}
              </p>
            ) : null}
            <InputField
              name="beneficiary_bank"
              label="Beneficiary Bank"
              numberLabel="2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.beneficiary_bank}
            />
            {formik.touched.beneficiary_bank &&
            formik.errors.beneficiary_bank ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.beneficiary_bank}
              </p>
            ) : null}
            <InputField
              name="account_number"
              label="Account Number"
              numberLabel="3"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.account_number}
            />
            {formik.touched.account_number && formik.errors.account_number ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.account_number}
              </p>
            ) : null}
            <div className="flex items-start gap-3">
              <div className="rounded-full text-white w-[35px] h-[35px] bg-[#DFDFDF] px-3 py-2 flex justify-center items-center">
                4
              </div>
              <div className="w-full flex flex-col gap-2">
                <label className="text-[18px]">
                  Names of all Authorized Signatories to Account
                </label>
                <textarea
                  className="px-4 py-2 bg-white border border-[#E6E6E6] rounded-md placeholder:text-[14px]"
                  rows="5"
                  name="signatories"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.signatories}
                />
                {formik.touched.signatories && formik.errors.signatories ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.signatories}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          <div className="flex justify-end gap-3">
            <button type="button">
              <p className="p-3 bg-[#CCC] rounded-md">Back</p>
            </button>
            <button className="h-[50px]" type="submit">
              <p className="h-[50px] flex items-center p-3 bg-[#213874] text-white rounded-md">
                {isLoading ? <TKIconSpinner /> : state ? "Edit" : "Create"}
              </p>
            </button>
          </div>
        </form>
      </div>
    </NGODashboardLayout>
  );
};

export default CreateProjectThree;
